export default __webpack_public_path__ + "static/media/serviceImg4.bec80647.svg";